<p [nbSpinner]="loading">
  <input placeholder="Введите название документа"
         nbInput
         fieldSize="small"
         [formControl]="searchControl"
         fullWidth
  />
</p>

<div class="results">
  @if (damItemVersions?.length) {
    <label class="form-label">Выбранный документ</label>
    <p>{{ damItem.header }}</p>

    <div *ngFor="let damItemVersion of damItemVersions" class="results-item">
      <app-secured-image src="/dam/get-image-dynamic-version/{{damItemVersion.id}}"/>
      <span class="header">Версия Id: {{ damItemVersion.id }} Версия Iid:{{ damItemVersion.iid }}</span>

      <button nbButton (click)="selectDamItemVersion(damItemVersion.id)" size="small">
        <nb-icon icon="plus-outline"/>
        Добавить эту версию
      </button>
    </div>

    <nb-card-footer>
      <button (click)="searchByKeyword(keyword)" nbButton>
        <nb-icon icon="chevron-left-outline"/>
        Вернуться назад
      </button>
    </nb-card-footer>

  } @else {

    @if (!damItems?.length && keyword) {
      <div class="empty">{{ translations.noResults }}</div>

    } @else if (damItems?.length) {
      <label class="form-label">Найденные документы</label>

      <div class="results-item" *ngFor="let damItem of damItems">
        <app-secured-image src="/dam/get-image-dynamic/{{damItem.id}}/50"/>
        <span class="header">{{ damItem.header }}</span>

        <button nbButton (click)="showVersionOfDamItem(damItem)" size="small">
          <nb-icon icon="eye"/>
          Выбрать
        </button>
      </div>

    } @else {
      <p>&nbsp;</p>
    }
  }
</div>
